export default "__VITE_ASSET__BQDxNRJU__"